import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading font-semibold text-foreground-900 text-base mb-3">Vigorbuy Spreadsheet</h4>
            <p className="text-xs text-foreground-600 leading-relaxed">
              An independent educational and product discovery platform. We help shoppers find better products through curated Vigorbuy Spreadsheet resources.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 text-sm mb-3">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <a href="/#categories" className="text-xs text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">Categories</a>
              <a href="/#what-is" className="text-xs text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">About</a>
              <a href="/#safety" className="text-xs text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">Safety</a>
              <a href="/#guides" className="text-xs text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">Guides</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 text-sm mb-3">Featured Guides</h4>
            <div className="flex flex-col gap-2">
              <Link to="/blog/how-to-use-vigorbuy-spreadsheet" className="text-xs text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">
                How to Use Vigorbuy Spreadsheet
              </Link>
              <Link to="/blog/best-vigorbuy-spreadsheet-categories" className="text-xs text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">
                Best Categories Guide
              </Link>
              <Link to="/blog/is-vigorbuy-spreadsheet-safe" className="text-xs text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">
                Safety & Security Review
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 text-sm mb-3">Main Website</h4>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-accent-500 text-background-50 px-5 py-2.5 rounded-md text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Visit kaspreadsheet.com
              <i className="ri-arrow-right-up-line text-sm"></i>
            </a>
            <p className="text-xs text-foreground-500 mt-3">
              Explore the full Vigorbuy Spreadsheet product catalog on our main website.
            </p>
          </div>
        </div>

        <div className="border-t border-background-200 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Vigorbuy Spreadsheet Resource. All rights reserved.
          </p>
          <Link to="/" className="text-xs text-foreground-500 hover:text-accent-600 transition-colors cursor-pointer">
            vigorbuyspread.com
          </Link>
        </div>
      </div>
    </footer>
  );
}